import { HeroSection } from "@/components/home/HeroSection";
import { Seo } from "@/components/Seo";
import { TrustBar } from "@/components/home/TrustBar";
import { StatsSection } from "@/components/home/StatsSection";
import { ServicesSection } from "@/components/home/ServicesSection";
import { HowItWorks } from "@/components/home/HowItWorks";
import { DualList } from "@/components/home/DualList";
import { WhySection } from "@/components/home/WhySection";
import { ResultsSection } from "@/components/home/ResultsSection";
import { Testimonials } from "@/components/home/Testimonials";
import { PricingSection } from "@/components/home/PricingSection";
import { FaqSection } from "@/components/home/FaqSection";
import { ContactCta } from "@/components/home/ContactCta";

export default function Home() {
    return (
        <div data-testid="home-page">
            <Seo
                title="DentAssists — Dental Billing & Insurance Verification in Texas"
                description="DentAssists handles insurance verification, billing, payment posting, AR follow-up, credentialing and reporting for dental practices in Texas and across the U.S. — inside your existing PM software. HIPAA-compliant."
                path="/"
            />
            <HeroSection />
            <TrustBar />
            <StatsSection />
            <ServicesSection />
            <HowItWorks />
            <DualList />
            <WhySection />
            <ResultsSection />
            <Testimonials />
            <PricingSection />
            <FaqSection />
            <ContactCta />
        </div>
    );
}
